import React from 'react';
import './Home.css';
import { Link } from 'react-router-dom';

function Home() {
  return (
    <div className="home">
      <div className="contents">
        <h1>Grow smarter together</h1>
        <p className='prs'>Find top-rated study notes from students <br />taking the same courses as you.</p>
        <div className="buttons">
          <Link to="/use" ><a href=' '><button className="btns__primary">Read</button></a></Link>
          <Link to="/cont"><a href=' '><button className="btns__secondary">Contribute</button></a></Link> 
        </div>
      </div>
    </div>
  );
}

export default Home;
